import { render, staticRenderFns } from "./MatchingStatistics.vue?vue&type=template&id=bedea690&"
import script from "./MatchingStatistics.vue?vue&type=script&lang=js&"
export * from "./MatchingStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports